import { useColorModeValue } from '@chakra-ui/react'

export type colors = {
  primaryColor: string
  secondaryColor: string
  menuBackgroundColor: string
  textColor: string
  whiteBlackColor: string
  textOnHover: string
  mainBackground: string
  borderColor: string
  blurGray: string
  secondaryBackgroundColor: string
  darkGray: string
}

export function useColor(): colors {
  return {
    primaryColor: useColorModeValue('#CC128C', '#442b48'),
    secondaryColor: '#000000',
    menuBackgroundColor: useColorModeValue('#F0F8FD', '#7d5c65'),
    textColor: useColorModeValue('#707070', '#a799b7'),
    whiteBlackColor: useColorModeValue('#ffffff', '#ffffff'),
    textOnHover: useColorModeValue('#65ACDB', 'purple.800'),
    mainBackground: useColorModeValue('white', 'gray.600'),
    borderColor: '#E6E6E6',
    blurGray: '#B9B9C4',
    darkGray: '#646460',
    secondaryBackgroundColor: '#F4F2F7',
  }
}
